// extracted by mini-css-extract-plugin
module.exports = {"item-container":"mochi-refueling-tutorial-carousel_item-container__5PpE5","item-content":"mochi-refueling-tutorial-carousel_item-content__fHGer"};